<app-navbar></app-navbar>
<div class="container-lg">
    <div class="my-container">
        <div class="section-body-container pt-5">
            <div class="card">
                <img class="card-img-top" src="assets/img/Logo.png" draggable="true"
                    alt="Imagen Principal de Administración">
                <div class="card-body">
                    <div class="row text-center p-4">
                        <div class="col-lg-12" *ngIf="validateRoles(newsRoles, role)">
                            <button type="button" class="btn btn-outline-dark outline-leer-mas" routerLink="/noticias">
                                <a class="nav-link">Módulo de Noticias</a>
                            </button>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="validateRoles(newsRoles, role)">
                            <button type="button" class="btn btn-outline-dark outline-leer-mas" routerLink="/agenda">
                                <a class="nav-link">Módulo de Agenda</a>
                            </button>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="validateRoles(plenaryRoles, role)">
                            <button type="button" class="btn btn-outline-dark outline-leer-mas"
                                routerLink="/documentos-plenaria">
                                <a class="nav-link">Módulo de Documentos plenaria</a>
                            </button>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="validateRoles(plenaryRoles, role)">
                            <button type="button" class="btn btn-outline-dark outline-leer-mas" routerLink="/diputados">
                                <a class="nav-link">Módulo de Diputados</a>
                            </button>
                        </div>
                      <!--   <div class="col-lg-12 mt-3" *ngIf="validateRoles(plenaryRoles, role)">
                            <button type="button" class="btn btn-outline-dark outline-leer-mas" routerLink="/diputados">
                                <a class="nav-link">Módulo de Usuarios</a>
                            </button>
                        </div> -->
                    </div>
                    <div class="row text-center p-4">
                        <div class="col-lg-12">
                            <button type="button" class="btn btn-outline-dark outline-leer-mas" (click)="logout()">
                                <a class="nav-link">Cerrar Sesión</a>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="text-center spinner-container" *ngIf="loading">
    <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
